import {
  ResqlExpertSubmissionResponse,
  UpdateAdminSubmissionRequest,
} from 'utils/api/resqlexpert.d';

export interface AdminFormValues {
  // Original (read-only)
  title: string;
  school_id: number;
  situation_description: string;
  information_sources: string[];
  actions_taken: string;
  involved_parties: string[];
  positive_outcomes: string;
  negative_outcomes: string;
  short_term_objectives: string;
  long_term_objectives: string;
  // Admin-editable
  assignee_id: number | null;
  comment_situation_description: string;
  comment_information_sources: string;
  comment_actions_taken: string;
  comment_involved_parties: string;
  comment_positive_outcomes: string;
  comment_negative_outcomes: string;
  comment_short_term_objectives: string;
  comment_long_term_objectives: string;
  is_completed: boolean;
  is_ready_for_training: boolean;
}

export const toFormValues = (detail: ResqlExpertSubmissionResponse): AdminFormValues => ({
  title: detail.title,
  school_id: detail.school_id,
  situation_description: detail.situation_description ?? '',
  information_sources: detail.information_sources ?? [],
  actions_taken: detail.actions_taken ?? '',
  involved_parties: detail.involved_parties ?? [],
  positive_outcomes: detail.positive_outcomes ?? '',
  negative_outcomes: detail.negative_outcomes ?? '',
  short_term_objectives: detail.short_term_objectives ?? '',
  long_term_objectives: detail.long_term_objectives ?? '',
  assignee_id: detail.assignee?.id ?? null,
  comment_situation_description: detail.comment_situation_description ?? '',
  comment_information_sources: detail.comment_information_sources ?? '',
  comment_actions_taken: detail.comment_actions_taken ?? '',
  comment_involved_parties: detail.comment_involved_parties ?? '',
  comment_positive_outcomes: detail.comment_positive_outcomes ?? '',
  comment_negative_outcomes: detail.comment_negative_outcomes ?? '',
  comment_short_term_objectives: detail.comment_short_term_objectives ?? '',
  comment_long_term_objectives: detail.comment_long_term_objectives ?? '',
  is_completed: detail.is_completed ?? false,
  is_ready_for_training: detail.is_ready_for_training ?? false,
});

export const buildUpdateRequest = (values: AdminFormValues): UpdateAdminSubmissionRequest => ({
  assignee_id: values.assignee_id ?? null,
  comment_situation_description: values.comment_situation_description || null,
  comment_information_sources: values.comment_information_sources || null,
  comment_actions_taken: values.comment_actions_taken || null,
  comment_involved_parties: values.comment_involved_parties || null,
  comment_positive_outcomes: values.comment_positive_outcomes || null,
  comment_negative_outcomes: values.comment_negative_outcomes || null,
  comment_short_term_objectives: values.comment_short_term_objectives || null,
  comment_long_term_objectives: values.comment_long_term_objectives || null,
  is_completed: values.is_completed,
  is_ready_for_training: values.is_ready_for_training,
});
